/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { StyleSheet, View } from 'react-native';
import { sortableHandle } from 'react-sortable-hoc/dist/react-sortable-hoc';

import { Text } from '../../uiold';
import { themeColors } from '../../uiold/Constants';

const HEIGHT = 24;

type Props = {
  showHandle?: boolean;
};

let DragHandle = sortableHandle(({ showHandle = true }: Props) => {
  return (
    <View style={styles.root}>
      {showHandle && <Text style={styles.handle}>:::</Text>}
    </View>
  );
});

// TODO: Is this necessary?
(DragHandle as any).height = HEIGHT;

let styles = StyleSheet.create({
  root: {
    height: HEIGHT,
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'move',
  },
  handle: {
    letterSpacing: 1,
    color: themeColors.darkGrey,
  },
});

export default DragHandle;
